import { useState } from 'react';
import { WinePackageWidgetModel } from '../../../../models/WinePackageWidgetModel';

interface UseCartQuantityProps {
  winePackage: WinePackageWidgetModel;
}

/**
 * The useCartQuantity hook returns the cart quantity of a wine package.
 * @param winePackage - The object containing information about the wine package.
 * @returns The useCartQuantity hook returns the cart quantity of a wine package.
 */

const useCartQuantity = ({ winePackage }: UseCartQuantityProps) => {
  const [cartQuantity, setCartQuantity] = useState(winePackage.minimumCartQuantity ?? 1);

  /**
   * The function `decrement` decreases the value of `cartQuantity` by 1 if it is greater than 1.
   */
  const decrement = () => {
    if (cartQuantity > 1 && cartQuantity > winePackage.minimumCartQuantity) setCartQuantity((prevState) => prevState - 1);
  };

  /**
   * The function `increment` increases the value of `cartQuantity` by 1 if it is less than `stock`.
   */
  const increment = () => {
    if (cartQuantity < winePackage.availableQuantity && cartQuantity < winePackage.maximumCartQuantity) setCartQuantity((prevState) => prevState + 1);
  };

  return { increment, decrement, cartQuantity };
};

export default useCartQuantity;
